import Vue from "vue";

export default {
  recuperarTiposProcesso() {
    return Vue.axios.get("tipoProcesso");
  },
};